// Do not modify. This is generated code.

import {
  Annual_report,
  Appointments,
  Aromatherapy,
  Awards,
  Baby,
  Back_and_neck,
  Bath,
  Blood_bag,
  Camera,
  Chat_visit,
  Classes_and_events,
  Covid_19_faq,
  Covid_19_mask,
  Covid_19_microscope,
  Covid_19_thermometer,
  Covid_19_vaccine,
  Diagnosis,
  Dna,
  Doctor_note,
  Doctor,
  Donate,
  Emergent_patient_transfer,
  Evisit,
  Feedback,
  Flu_vaccine,
  For_hips,
  For_knees,
  Heart,
  Information,
  Insurance,
  Jacket,
  Location,
  Map_pin,
  Mask,
  Meet_our_team,
  Mental_health,
  Mom_and_baby,
  Money,
  Mybsw,
  Nurse_and_baby,
  Palliative_care,
  Parents,
  Pills,
  Podcast,
  Proxy,
  Pulse,
  Quality,
  Rattler,
  Referral,
  Resource,
  Ribbon,
  Schedule,
  Scissors,
  Social_support,
  Spiritual_support,
  Sports_medicine,
  Strengthening,
  Stretch,
  Support_groups,
  Symbol,
  Target,
  Tools_and_resources,
  Video_visit,
  Volunteer,
  Walk_in,
  Warning,
  Water,
  Well_being,
  X_ray,
  BrandIconNameAvailable,
  BrandIconNameDeprecated
} from './BrandIconsTypes.generated';

import * as React from 'react';

export interface GeneratedBrandIconProps {
  color?: string;
  fill?: string;
  height?: number;
  icon?: BrandIconNameAvailable;
  width?: number;
}

const GeneratedBrandIconMap = {
  ['annual-report']: Annual_report,
  ['appointments']: Appointments,
  ['aromatherapy']: Aromatherapy,
  ['awards']: Awards,
  ['baby']: Baby,
  ['back-and-neck']: Back_and_neck,
  ['bath']: Bath,
  ['blood-bag']: Blood_bag,
  ['camera']: Camera,
  ['chat-visit']: Chat_visit,
  ['classes-and-events']: Classes_and_events,
  ['covid-19-faq']: Covid_19_faq,
  ['covid-19-mask']: Covid_19_mask,
  ['covid-19-microscope']: Covid_19_microscope,
  ['covid-19-thermometer']: Covid_19_thermometer,
  ['covid-19-vaccine']: Covid_19_vaccine,
  ['diagnosis']: Diagnosis,
  ['dna']: Dna,
  ['doctor-note']: Doctor_note,
  ['doctor']: Doctor,
  ['donate']: Donate,
  ['emergent-patient-transfer']: Emergent_patient_transfer,
  ['evisit']: Evisit,
  ['feedback']: Feedback,
  ['flu-vaccine']: Flu_vaccine,
  ['for-hips']: For_hips,
  ['for-knees']: For_knees,
  ['heart']: Heart,
  ['information']: Information,
  ['insurance']: Insurance,
  ['jacket']: Jacket,
  ['location']: Location,
  ['map-pin']: Map_pin,
  ['mask']: Mask,
  ['meet-our-team']: Meet_our_team,
  ['mental-health']: Mental_health,
  ['mom-and-baby']: Mom_and_baby,
  ['money']: Money,
  ['mybsw']: Mybsw,
  ['nurse-and-baby']: Nurse_and_baby,
  ['palliative-care']: Palliative_care,
  ['parents']: Parents,
  ['pills']: Pills,
  ['podcast']: Podcast,
  ['proxy']: Proxy,
  ['pulse']: Pulse,
  ['quality']: Quality,
  ['rattler']: Rattler,
  ['referral']: Referral,
  ['resource']: Resource,
  ['ribbon']: Ribbon,
  ['schedule']: Schedule,
  ['scissors']: Scissors,
  ['social-support']: Social_support,
  ['spiritual-support']: Spiritual_support,
  ['sports-medicine']: Sports_medicine,
  ['strengthening']: Strengthening,
  ['stretch']: Stretch,
  ['support-groups']: Support_groups,
  ['symbol']: Symbol,
  ['target']: Target,
  ['tools-and-resources']: Tools_and_resources,
  ['video-visit']: Video_visit,
  ['volunteer']: Volunteer,
  ['walk-in']: Walk_in,
  ['warning']: Warning,
  ['water']: Water,
  ['well-being']: Well_being,
  ['x-ray']: X_ray,
};

export const GeneratedBrandIcon = (props: GeneratedBrandIconProps) => {
  const Component = GeneratedBrandIconMap[props.icon!];
  if (!Component) {
    throw new Error('icon "' + props.icon + '" not found in set "brand"');
  }
  return <Component {...props} />;
};
